import React, {Component} from 'react';
import GameForm from '../../../../../../components/form/game-form';
import DocumentTitle from '../../../../../../components/document-title';
import {connect} from 'react-redux';
import {bindActionToPromise} from '../../../../../../utils/redux-form';
import {saveNewGame} from './modules/game-new-actions';
import {openGamesList} from '../../../../../../actions/flow-actions';
import SweetAlert from '../../../../../../components/sweet-alert';

class NewGameContainer extends Component {

    state = {
        showAlert: false,
        gameId: null
    };

    onSubmitSuccess = (values) => {
        this.setState({gameId: values.id, showAlert: true});
    };

    hideSaveAlert = () => {
        this.props.dispatch(openGamesList());
        this.setState({showAlert: false});
    };

    render() {
        return (
            <DocumentTitle title="Naujos rungtynės">
                <div>
                    {this.state.showAlert ?
                        <SweetAlert success={true} title="Rungtynės išsaugotos" onConfirm={this.hideSaveAlert}/> : null
                    }
                    <GameForm onSubmit={this.props.actions.onSubmit} onSubmitSuccess={this.onSubmitSuccess} leagues={this.props.leagues}/>
                </div>
            </DocumentTitle>);
    }
}

export default connect((state) => {
    return {
        leagues: state.user.currentUser ? state.user.currentUser.leagues: [],
    };
}, (dispatch) => {
    return {
        actions: {
            onSubmit: bindActionToPromise(dispatch, saveNewGame)
        },
        dispatch
    };
})(NewGameContainer);



// WEBPACK FOOTER //
// ./src/js/routes/app/routes/games/routes/new/game-new-container.jsx